/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import { Component, Vue } from 'vue-property-decorator';
import Loader from '@/components/Loader/index.vue';

/**
 * Site navigation component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-overlay-disable',
    components: {
        'c-loader': Loader,
    },
})

export default class OverlayDisable extends Vue {
}
